/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
/* eslint-disable arrow-body-style */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-plusplus */
/* eslint-disable radix */

const CPF_LENGTH = 11
const CNPJ_LENGTH = 14

const ALPHANUMERIC_MAP: Record<string, number> = {
  '0': 0,
  '1': 1,
  '2': 2,
  '3': 3,
  '4': 4,
  '5': 5,
  '6': 6,
  '7': 7,
  '8': 8,
  '9': 9,
  A: 17,
  B: 18,
  C: 19,
  D: 20,
  E: 21,
  F: 22,
  G: 23,
  H: 24,
  I: 25,
  J: 26,
  K: 27,
  L: 28,
  M: 29,
  N: 30,
  O: 31,
  P: 32,
  Q: 33,
  R: 34,
  S: 35,
  T: 36,
  U: 37,
  V: 38,
  W: 39,
  X: 40,
  Y: 41,
  Z: 42,
}

interface AllValidates {
  validateCNPJ: (value: string) => boolean
  validateCPF: (value: string) => boolean
  validateEmail: (value: string) => boolean
  validatePhone: (value: string) => boolean
  domainValidation: (value: string) => boolean
  validateName: (value: string) => boolean
  validateOrganizationIdAndSStatementId: (value: string) => boolean
}

const sanitizeTaxNumber = (value: string, length: number): string => {
  if (!value) {
    return ''
  }

  const str = String(value).replace(/[^\w]/g, '')

  if (length === CNPJ_LENGTH) {
    return str.trim()
  }

  return str.trim().padStart(length, '0')
}

function isRepeatedSequence(value: string, length: number): boolean {
  if (value.length !== length) {
    return false
  }

  const regex = new RegExp(`^(.)\\1{${length - 1}}$`)
  return regex.test(value)
}

const validateCNPJDigits = (cnpj: string): boolean => {
  const digits: number[] = []

  for (const char of cnpj) {
    const val = ALPHANUMERIC_MAP[char.toUpperCase()]

    if (val === undefined) {
      return false
    }

    digits.push(val)
  }

  if (digits.length !== CNPJ_LENGTH) return false

  // Primeiro dígito verificador
  let sum = 0
  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  for (let i = 0; i < 12; i++) {
    sum += digits[i] * weights1[i]
  }
  let remainder = sum % 11
  const firstDigit = remainder < 2 ? 0 : 11 - remainder
  if (digits[12] !== firstDigit) return false

  // Segundo dígito verificador
  sum = 0
  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

  for (let i = 0; i < 13; i++) {
    sum += digits[i] * weights2[i]
  }

  remainder = sum % 11
  const secondDigit = remainder < 2 ? 0 : 11 - remainder
  return digits[13] === secondDigit
}

const allValidates: AllValidates = {
  validateEmail: (value: string) => {
    if (
      String(value)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        )
    ) {
      return true
    }
    return false
  },

  /**
   * Valida CPF (apenas numérico).
   * @param value - string com ou sem formatação
   * @returns true se CPF válido
   */
  validateCPF: (value: string) => {
    let Soma = 0

    if (value === undefined) {
      return false
    }

    const cleaned = sanitizeTaxNumber(value, CPF_LENGTH)

    if (
      cleaned.length !== CPF_LENGTH ||
      isRepeatedSequence(cleaned, CPF_LENGTH)
    ) {
      return false
    }

    for (let i = 1; i <= 9; i++) {
      Soma += parseInt(cleaned.substring(i - 1, i)) * (CPF_LENGTH - i)
    }

    let Resto = (Soma * 10) % CPF_LENGTH
    if (Resto === 10 || Resto === CPF_LENGTH) {
      Resto = 0
    }

    if (Resto !== parseInt(cleaned.substring(9, 10))) {
      return false
    }

    Soma = 0
    for (let k = 1; k <= 10; k++) {
      Soma += parseInt(cleaned.substring(k - 1, k)) * (12 - k)
    }

    Resto = (Soma * 10) % CPF_LENGTH
    if (Resto === 10 || Resto === CPF_LENGTH) {
      Resto = 0
    }

    if (Resto !== parseInt(cleaned.substring(10, CPF_LENGTH))) {
      return false
    }

    return true
  },

  /**
   * Valida CNPJ (incluindo alfanumérico).
   * Rejeita sequências repetidas e valores inválidos.
   * @param value - string, número, undefined ou null
   * @returns true se CNPJ válido
   */
  validateCNPJ(value: string): boolean {
    if (!value) {
      return false
    }

    const cleaned = sanitizeTaxNumber(value, CNPJ_LENGTH)
    if (cleaned.length !== CNPJ_LENGTH) {
      return false
    }

    if (isRepeatedSequence(cleaned, CNPJ_LENGTH)) {
      return false
    }

    const lastTwo = cleaned.slice(-2)

    if (!/^\d{2}$/.test(lastTwo)) {
      return false
    }

    return validateCNPJDigits(cleaned)
  },

  validatePhone(value: string) {
    if (value.length < 11) {
      return false
    }

    return true
  },

  domainValidation(value: string): boolean {
    const regex =
      /^((?!\d+\.)([\p{L}0-9][\p{L}0-9\-]{0,24}[\p{L}0-9])\.)+[\p{L}]{2,}$/u
    const match = value.match(regex)
    return match !== null
  },

  validateName(value: string) {
    if (value.match(/^[a-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÒÖÚÇÑ ]+$/i)) {
      return true
    }

    return false
  },

  validateOrganizationIdAndSStatementId(value: string) {
    // const REGEX_UUID = '/^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/';
    const REGEX_UUID =
      '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$'
    const match = value.match(REGEX_UUID)
    return match !== null
  },
}

export default allValidates
